@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
<div class="flex-col w-100 justify-stretch items-stretch">
  @if (propertyBidHistory?.auctionBidHistories?.length) {
    <mat-tab-group class="w-100">
      @for (abh of propertyBidHistory!.auctionBidHistories; track abh.auctionId + '-' + abh.scheduleSeqNo) {
        <mat-tab class="w-100" [label]="'Auction ' + abh.scheduleSeqNo + abh.voidInfo + ': ' + abh.auctionBids.length + ' bid(s)'">
          @if (abh.auctionBids.length) {
            <app-bidding-history-public [bids]="abh.auctionBids" [auctionType]="auctionType()"></app-bidding-history-public>
          }
          @else {
            <p class="py-3 mb-0 text-center">No bids</p>
          }
        </mat-tab>
      }
    </mat-tab-group>
  }
  @else if (!busy) {
    <p class="py-3 mb-0 text-center">No bids</p>
  }
</div>
